




































import Modal from "../../core/Modals/Modal.vue";
import EmployeSelect from "../../core/Forms/EmployeSelect.vue";
import { InterventionApi } from "../../api/InterventionApi";
import { Intervention } from "../../models/Intervention";
import { Employe } from "../../models/Employe";

export default {
    name: "InterventionReassignEmployeEdit",
    components: { EmployeSelect, Modal },
    props: {
        interventions: Array,
    },
    data() {
        return {
            showModal: true,
            saving: false,
            selectedEmployes: [],
            InterventionApi: new InterventionApi(),
        };
    },
    created() {
        this.selectedEmployes = _.chain(this.interventions)
            .map("employes")
            .flatten()
            .filter(function (e) {
                return e.id;
            })
            .uniqBy("id")
            .map(function (data) {
                return new Employe(data);
            })
            .value();
    },
    methods: {
        closeModal: function (): void {
            this.$emit("close-modal");
        },
        saveData: function (): void {
            let self = this;
            let promises = [];

            if (self.saving) {
                return;
            }

            self.saving = true;

            _.forEach(self.interventions, function (interventionData) {
                let intervention = new Intervention(interventionData);
                intervention.employes = self.selectedEmployes;
                let promise = self.InterventionApi.save(intervention).then(
                    function (res) {
                        return res;
                    }
                );
                promises.push(promise);
            });
            Promise.all(promises).then(function () {
                self.closeModal();
            });
        },
    },
};
